module.exports = __webpack_public_path__ + "img/ad8x25__gb882.prt.2cb9967d.jpg";